module.exports = __webpack_public_path__ + "img/GetItOnGooglePlay_Badge_Web_color_German.3ea40ccd.png";